import styled from '@emotion/styled';
import { Tooltip } from 'antd';
import moment from 'moment';
import { useState } from 'react';
import { FaHistory } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { BROWN, PRIMARY, YELLOW } from '../../../../shared/colors';
import { formatNum } from '../../../../shared/constants';

const Container = styled.div`
  > .top {
    background-color: ${PRIMARY};
    padding: 5px;
    font-family: Poppins-R;
    border-radius: 10px;
    text-transform: uppercase;
    display: flex;
    justify-content: space-between;
    padding-left: 10px;
    font-size: 15px;
  }

  > .content {
    padding: 5px;
    font-family: Poppins-R;

    > p {
      text-align: center;
    }
  }
`;

export const GraphData = ({ marketData }: { marketData: any[] }) => {
  const [page, setPage] = useState('1');

  const changeContent = () => {
    if (page === '1') setPage('2');
    else setPage('1');
  };

  return (
    <Container>
      <div className='top'>
        <div style={{ color: 'orange' }}>
          {page === '1'
            ? 'Profondeur du marché'
            : 'Historique graphique des données'}
        </div>
        <div>
          <Tooltip
            title={page === '1' ? 'Données graphique' : 'Profondeur du marché'}
            color={YELLOW}
            placement='rightBottom'
          >
            <FaHistory
              style={{ cursor: 'pointer' }}
              size={18}
              onClick={changeContent}
            />
          </Tooltip>
        </div>
      </div>

      <div className='content'>
        {page === '1' ? (
          <Profondeur marketData={marketData} />
        ) : (
          <p>Aucune donnée n'est disponible</p>
        )}
      </div>
    </Container>
  );
};

const ProfContainer = styled.div`
  font-family: Poppins-R;

  * {
    border: 1px solid grey;
  }

  .top-line > td {
    text-align: center;
    font-size: 12px;
    font-style: italic;
  }

  .body > td {
    padding: 0px 3px;
    font-size: 12px;
    text-align: right;
  }

  table {
    width: 100%;
  }

  thead {
    background-color: ${PRIMARY};
  }
`;

const Profondeur = ({ marketData }: { marketData: any[] }) => {
  const connUserId = useSelector((state: any) => state.userReducer).user.id;

  const color = (user: any) =>
    connUserId === user ? { color: BROWN } : { color: 'white' };

  return (
    <ProfContainer>
      <table>
        <thead>
          <tr>
            <th colSpan={3}>Achats</th>
            <th colSpan={3}>Ventes</th>
          </tr>
        </thead>
        <tbody>
          <tr className='top-line'>
            <td>Nb Jours</td>
            <td>Qte achat</td>
            <td>Prix achat</td>
            <td>Prix vente</td>
            <td>Qte vente</td>
            <td>Nb Jours</td>
          </tr>
          {marketData.map((val, index) => (
            <tr key={index} className='body'>
              <td style={color(val.userAchat)}>
                {val.dateAchat === '--'
                  ? '--'
                  : moment(new Date()).diff(moment(val.dateAchat), 'days') || 0}
              </td>
              <td style={color(val.userAchat)}>{formatNum(val.qteAchat)}</td>
              <td style={color(val.userAchat)}>{formatNum(val.prixAchat)}</td>
              <td style={color(val.userVente)}>{formatNum(val.prixVente)}</td>
              <td style={color(val.userVente)}>{formatNum(val.qteVente)}</td>
              <td style={color(val.userVente)}>
                {val.dateVente === '--'
                  ? '--'
                  : moment(new Date()).diff(moment(val.dateVente), 'days') || 0}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </ProfContainer>
  );
};
